import Head from 'next/head';
import { appWithTranslation } from 'next-i18next';

import { GTMInitializer } from '@kc-console/context';

import NextI18nextConfig from '../next-i18next.config';

import type { ExtendedAppProps } from '@/application/types';

import DefaultLayout from '@/application/layouts/DefaultLayout';
import { AppProviders, ErrorBoundary, SentryInitializer } from '@/application/providers';
import { getServiceConstants } from '@/shared/config/routes';

function App(props: ExtendedAppProps) {
  const { Component, pageProps } = props;
  const { dehydratedState, ...others } = pageProps;
  const { SERVICE_TITLE } = getServiceConstants();
  const renderComponent = () => {
    return Component.getCustomLayout ? (
      Component.getCustomLayout(<Component {...others} />, others)
    ) : (
      <DefaultLayout>
        <Component {...others} />
      </DefaultLayout>
    );
  };

  return (
    <>
      <Head>
        <title>{SERVICE_TITLE}</title>
      </Head>
      <AppProviders appProps={props} dehydratedState={dehydratedState}>
        <SentryInitializer />
        <GTMInitializer />
        <ErrorBoundary>{renderComponent()}</ErrorBoundary>
      </AppProviders>
    </>
  );
}

export default appWithTranslation(App, NextI18nextConfig);
